
<div class="modal-header mfp-header">
    <h5 class="modal-title">Task Types</h5>
    <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="Cancel()"
    ></button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="row my-2" *ngFor="let taskType of TaskTypes; index as i; first as isFirst">
            <div class="col-12 col-md-6"><span *ngIf="isFirst">Task Types:</span></div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="taskType.Name" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6 offset-md-6">
                <input type="text" class="form-control" [(ngModel)]="NewTaskTypeName" (blur)="AddTaskType()" />
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="Cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="Save()">Save</button>
</div>
